import React from 'react';

/**
 * «EN SEGUIMIENTO» Y «CAUTION» (administración, 4/11/2026)
 * --------------------------------------------------------
 * Los dos indicadores del paciente junto a su nombre: en la ficha, en la
 * agenda, en el resumen de la cita y en el parte del día (el impreso los lleva
 * igual: services/agenda_dia_pdf_generator.py, con los mismos colores).
 *
 * Colores fijos y distintos de los que ya había: ni el rojo de «PROHIBIDO»
 * ni el de una marca de paciente (rosa palo la de la clínica). Índigo para el
 * seguimiento, ámbar para la precaución. Sin emojis: texto.
 *
 * Donde van dentro de algo que ya se pulsa (una cita de la agenda) se pintan
 * sin botón; el `title` dice la nota de Caution, que es de uso interno (el
 * listado de citas es de personal; al conector no le llega).
 */
export const COLOR_SEGUIMIENTO = '#4338CA';
export const COLOR_CAUTION = '#B45309';

const TAMANOS = {
  normal: 'text-xs px-2 py-0.5',
  pequeno: 'text-[10px] px-1.5 py-[1px]',
  mini: 'text-[9px] px-1 py-0 leading-[14px]',
};

const BASE = 'inline-flex shrink-0 items-center rounded font-bold uppercase tracking-wide '
  + 'text-white leading-none whitespace-nowrap align-middle';

export function tituloCaution(nota) {
  const n = String(nota || '').trim();
  return n ? `Caution (precaución). Nota de uso interno: ${n}` : 'Caution: paciente con precaución';
}

export const TITULO_SEGUIMIENTO = 'Paciente en seguimiento';

export function IndicadorSeguimiento({ tamano = 'normal', testId = 'indicador-seguimiento', className = '' }) {
  return (
    <span
      className={`${BASE} ${TAMANOS[tamano] || TAMANOS.normal} ${className}`.trim()}
      style={{ backgroundColor: COLOR_SEGUIMIENTO }}
      title={TITULO_SEGUIMIENTO}
      role="img"
      aria-label={TITULO_SEGUIMIENTO}
      data-testid={testId}
    >
      En seguimiento
    </span>
  );
}

export function IndicadorCaution({ nota, tamano = 'normal', testId = 'indicador-caution', className = '' }) {
  const titulo = tituloCaution(nota);
  return (
    <span
      className={`${BASE} ${TAMANOS[tamano] || TAMANOS.normal} ${className}`.trim()}
      style={{ backgroundColor: COLOR_CAUTION }}
      title={titulo}
      role="img"
      aria-label={titulo}
      data-testid={testId}
    >
      Caution
    </span>
  );
}

/**
 * Los dos de una cita (o de una ficha), uno detrás de otro. Sin ninguno,
 * nada. Lee `en_seguimiento` / `caution` / `caution_nota` de la cita, o los
 * sueltos.
 */
export default function IndicadoresSeguimiento({
  cita, enSeguimiento, caution, cautionNota, tamano = 'mini', testId = 'cita-seguimiento', className = '',
}) {
  const seg = enSeguimiento ?? cita?.en_seguimiento === true;
  const cau = caution ?? cita?.caution === true;
  if (!seg && !cau) return null;
  const nota = cautionNota ?? cita?.caution_nota;
  return (
    <span className={`inline-flex items-center gap-1 align-middle ${className}`.trim()} data-testid={testId}>
      {seg && <IndicadorSeguimiento tamano={tamano} testId={`${testId}-seguimiento`} />}
      {cau && <IndicadorCaution nota={nota} tamano={tamano} testId={`${testId}-caution`} />}
    </span>
  );
}
